module.exports = __webpack_public_path__ + "static/media/add-circle.0cd6f672.svg";